function shopHostname() {
    // Ziggy 2 exposes only `url`; the pre-2.0 `baseDomain` property no longer exists.
    try {
        return new URL(Ziggy.url).hostname;
    } catch {
        return window.location.hostname;
    }
}

export function isPartnershop() {
    /*
    * Provides information about whether the current shop is a partner shop (true/false):
    * import { isPartnershop } from '@/globalFunctions'
    * if (isPartnershop()) { ... } else { ... }
    */
    return shopHostname().split('.').length > 2;
}

export function subdomainShop() {
    return shopHostname().split('.');
}

export function getCartCookie() {
    /*
    * Provides the cart cookie:
    * import { getCartCookie } from '@/globalFunctions'
    * const cart = getCartCookie()
    */
    return document.cookie
        .split('; ')
        .find(row => row.startsWith('mt-2019-cart='))
        ?.split('=')[1];
}

export function deleteCartCookie() {
    /*
    * Deletes the cart cookie:
    * import { deleteCartCookie } from '@/globalFunctions'
    * deleteCartCookie()
    */
    document.cookie = 'mt-2019-cart=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

function normalizeGuestCartId(id) {
    if (id === null || id === undefined) return null;
    const value = String(id).replace(/^"|"$/g, '').trim();
    if (!value || value === 'null' || value === 'undefined') return null;
    return value;
}

function storedCurrentCartId() {
    try {
        return localStorage.getItem('currentCartId');
    } catch {
        return null;
    }
}

export function resolveGuestCartId(storeCartId = null) {
    return normalizeGuestCartId(storeCartId)
        || normalizeGuestCartId(storedCurrentCartId())
        || normalizeGuestCartId(getCartCookie());
}



export const routeHelper = (...args) => route(...args, Ziggy);

// -------------------- DATE/TIME HELPERS --------------------
export function formattedDate(dateInput) {
    return (
      (dateInput.getUTCDate() < 10 ? '0' : '') + dateInput.getUTCDate() + '.' +
      (dateInput.getUTCMonth() + 1 < 10 ? '0' : '') + (dateInput.getUTCMonth() + 1) + '.' +
      dateInput.getFullYear() + ' ' +
      (dateInput.getHours() < 10 ? '0' : '') + dateInput.getHours() + ':' +
      (dateInput.getMinutes() < 10 ? '0' : '') + dateInput.getMinutes() + ':' +
      (dateInput.getSeconds() < 10 ? '0' : '') + dateInput.getSeconds()
    )
  }
  
  
// -------------------- CURRENCY HELPERS --------------------
export function currencyFormat(value, curr) {
    let currency = '€'
    switch (curr) {
        case '€':
        case 'EUR':
        currency = '€'
        break
        case '$':
        case 'USD':
        currency = '$'
        break
    }
    return (
        value
        .toFixed(2)
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' ' + currency
    )
}

export function getUrlParam(parameter, defaultvalue){
    var urlparameter = defaultvalue;
    if(window.location.href.indexOf(parameter) > -1){
        urlparameter = getUrlVars()[parameter];
    }
    return urlparameter;
}

export function urldecode(url) {
    return decodeURIComponent(url.replace(/\+/g, ' '));
}

// -------------------- SORTING HELPERS --------------------
export function getSortParams(cols = []) {
    if (!Array.isArray(cols) || cols.length === 0) return ''

    return cols
    .map((col) => {
        const key = typeof col === 'object' ? col.key : col
        const isDesc = typeof col === 'object' ? col.order === 'desc' : false
        return (isDesc ? '-' : '') + key
    })
    .join(',')
}